<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.announcement.create")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineAnnouncementForm :APIbaseURL="APIbaseURL" :announcement="announcement" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineAnnouncementForm } from 'aveine-changelog';
import { Announcement } from 'aveine-toolbox';

export default {
  data () {
    return {
      announcement: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineAnnouncementForm
  },
  async created() {
    this.announcement = await Announcement.new()
    this.announcement.markdown = {}
    this.announcement.$isNew = true;
    this.dataLoaded = true;
  },
}
</script>
